import * as React from 'react';
import { FormattedPlural, useIntl } from 'react-intl';

import messages from '../../../messages';

export const RatingsPlural = ({
  productRatingCount,
}: {
  productRatingCount: number;
}) => {
  const { formatMessage } = useIntl();
  return (
    <FormattedPlural
      value={productRatingCount}
      one={formatMessage(messages.totalRatingsOne)}
      other={formatMessage(messages.totalRatingsOther)}
      few={formatMessage(messages.totalRatingsFew)}
    />
  );
};
